import { ObjectPath } from './types'
/* eslint-disable guard-for-in */
export const replacePath = (text: string, obj: ObjectPath | any) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    text = text.replace(`\${${key}}`, obj[key])
  }
  return text
}
